import React, { useContext, useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import DocumentMeta from "react-document-meta";
import ExpandableBox from "../Components/ExpandableBox";
import HeaderBanner from "../Components/HeaderBanner";
import FaqSideBar from "../Components/FaqSideBar";
import Config from "../config.json";
import Loading from "./Loading";
import ComponentContext from "../Context";
import FaqImage from "../Images/faq.png";
import Statics from "../Statics";

const page_meta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: Config.title + " | پرسش‌های متداول",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "پژوهیار",
    },
  },
};

const title = "پرسش‌های متداول";
const body =
  "صفحه پرسش‌های متداول شامل پرسش‌های پرتکرار کاربران، پاسخ و راهنمایی در بخش‌های مختلف نرم‌افزار پژوهیار است.";

const Faq = () => {
  const context = useContext(ComponentContext);

  const [loading_state, set_loading_state] = useState(Statics.NOT_LOADED);
  const [questions, set_questions] = useState([]);
  const [selectedFaqCategory, setSelectedFaqCategory] = useState([]);
  const handleCategorySelect = link => {
    setSelectedFaqCategory(link);
  };

  function getQuestions() {
    set_loading_state(Statics.LOADING);
    const storedFaqs = sessionStorage.getItem("allFaqs");
    const defaultQ = sessionStorage.getItem("defaultQ");
    if (storedFaqs) {
      const parsedStoredFaqs = JSON.parse(storedFaqs);
      const parsedDefaultQ = JSON.parse(defaultQ);
      set_questions(parsedStoredFaqs);
      setSelectedFaqCategory(parsedDefaultQ);
      set_loading_state(Statics.LOADED);
    } else {
      context.ApiDriver.getStaticValue(
        {
          slugs: ["faq_questions"],
        },
        (data, meta) => {
          set_questions(data.data[0].value);
          setSelectedFaqCategory(data.data[0].value[1]);
          sessionStorage.setItem("allFaqs", JSON.stringify(data.data[0].value));
          sessionStorage.setItem(
            "defaultQ",
            JSON.stringify(data.data[0].value[1]),
          );
          set_loading_state(Statics.LOADED);
        },
        error => {
          console.log(error);
          set_loading_state(Statics.CAUSED_ERROR);
        },
      );
    }
  }

  useEffect(() => {
    if (loading_state === Statics.NOT_LOADED) {
      getQuestions();
    }
    // eslint-disable-next-line
  }, [loading_state]);

  return (
    <DocumentMeta {...page_meta}>
      <HeaderBanner
        image={FaqImage}
        body={body}
        title={title}
        header_color="#eef0ff"
      />
      <div>
        <Row className="p-4 p-md-5 mx-0">
          {loading_state === Statics.LOADING ? (
            <div className="pajoohyar-loading">
              <Loading />
            </div>
          ) : null}
          {loading_state === Statics.CAUSED_ERROR ? (
            <div className="version-error-parent">
              <p>ارتباط با سرور با مشکل مواجه شد !</p>
              <img
                className="version-error-img"
                src="images/errorPic.webp"
                width="200px"
                alt="error-png"
              />
            </div>
          ) : null}
          <Col md={3} className="mb-3 mb-md-0 p-0 pl-0 pl-md-3">
            {loading_state === Statics.LOADED ? (
              <FaqSideBar
                links={questions}
                onCategorySeclect={handleCategorySelect}
              />
            ) : null}
          </Col>

          {loading_state === Statics.LOADED ? (
            <Col md={9} className="container-content-with-sidebar">
              <h5 className="questions-title">{selectedFaqCategory.value}</h5>
              <div className="px-3">
                <ExpandableBox data={selectedFaqCategory.questions} />
              </div>
            </Col>
          ) : null}
        </Row>
      </div>
    </DocumentMeta>
  );
};

export default Faq;
